import React from "react";
import ReactModal from "react-modal";
import { Link } from "react-router-dom";
import "./Modal.css";
// import x from "./twitter-icon-white.png"
// import { useHistory } from "react-router-dom";

ReactModal.setAppElement(document.getElementById("root"));

export const ModalNavBar = ({
  children,
  onClick,
  hide,
  icon,
  className,
  iconClassName,
}) => {
  const handleLogoClick = () => {
    window.scrollTo(0, 0);
    hide && hide();
  };

  return (
    <div className={`rainfall-modal-navbar ${className ? className : ""}`}>
      <div className="content-logo">
        <Link to={"/"} onClick={handleLogoClick}>
          <h1>R.</h1>
        </Link>
      </div>
      {children}
      <div className="content-icon-container">
        <button
          className={`content-icon ${iconClassName ? iconClassName : ""}`}
          onClick={onClick}
        >
          {icon}
        </button>
      </div>
    </div>
  );
};

const ModalFootervv = ({ hide }) => {
  return (
    <div className="rainfall-modal-footer">
      <div className="content-bot-container">
        <h6>© 2026 Rainfall AG.</h6>
        <p>
          Governance infrastructure for self-sovereign Personal AI in the agentic era.
        </p>
        <p>
          Dammstrasse 16, 6300 Zug
          <br /> Switzerland <br />
        </p>
        <div className="content-bot-links">
          <Link to={"https://rainfall.one/terms"} target="_blank" onClick={hide}>
            Terms of Use
          </Link>
          <Link to={"https://rainfall.one/privacy"} target="_blank" onClick={hide}>
            Privacy
          </Link>
        </div>
        <div className="content-bot-social">
        <a
            style={{ color: "#828282" }}
            href="https://www.instagram.com/rainfall.one/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="icon">
              <img
                style={{ height: "18px" }}
                src="/instagram.svg"
                alt="instagram-icon"
              />
            </span>
          </a>
        <a
            style={{ color: "#828282" }}
            href="https://twitter.com/rainfall_one"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="icon">
              <img
                style={{ height: "18px" }}
                src="/twitter.svg"
                alt="twitter-icon"
              />
            </span>
          </a>
         
          <a
            href="https://www.linkedin.com/company/rainfall-one"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="icon">
              <img
                style={{ height: "18px" }}
                src="/linkedin.svg"
                alt="linkedin-icon"
              />
            </span>
          </a>
          <a
            href="https://t.me/rainfall_one"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="icon">
              <img
                style={{ height: "18px", color: "#828282" }}
                src="/telegram.svg"
                alt="telegram-icon"
              />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export const Footer = ({ hide }) => {
  return (
    <div className="rainfall-modal-footer-container">
      <ModalFootervv hide={hide} />
    </div>
  );
};


